/**
 * Created by vladislav on 29.04.2022
 */

const WindowTitle = cc.Node.extend({ 
    ctor: function (withBg, options, help) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);
        this.setLocalZOrder(2);
        this.setVisible(false);

        this.withBg = withBg;
        this.type = this.withBg ? cleverapps.styles.WindowTitle.Types.bg_window : cleverapps.styles.WindowTitle.Types.nobg_window;
        this.help = help;

        this.windowRect = cc.rect(0, 0, 0, 0);

        if (this.type.background) {
            this.background = cleverapps.UI.createScale9Sprite(this.type.background.image);
            this.addChild(this.background);
        }

        this.textFont = !this.withBg ? cleverapps.styles.FONTS.NOBG_WINDOW_TITLE_TEXT : cleverapps.styles.FONTS.WINDOW_TITLE_TEXT;
        this.text = cleverapps.UI.generateOnlyText("", this.textFont);
        if (this.type.fontSize) {
            this.text.setFontSize(this.type.fontSize[cleverapps.resolution.mode]);
        }
        this.maxTextHeight = this.text.getFontSize() * 1.5;
        this.addChild(this.text, 1);

        let text = options;
        if (options.text) {
            text = options.text;
        }

        if (this.help) {
            this.helpButton = new cleverapps.UI.HelpButton({
                type: this.type.helpButton.type,
                callback: this.help
            });
            this.addChild(this.helpButton);
        }

        this.setScale(this.type.scale[cleverapps.resolution.mode]);
        this.setTitle(text);

        this.setCascadeOpacityEnabledRecursively(true);
    },

    setDecors: function (decors) {
        this.decors = decors;

        if (this.decors) {
            if (this.type.background) {
                this.decors.initTitleDecorators();
            }
        }
    },

    refresh: function (window) {
        this.windowRect = cc.rect(window);
        this.setScale(this.type.scale[cleverapps.resolution.mode]);
        this.onResize();

        if (this.withBg) {
            this.setAlignment(this.type.position);
        } else {
            this.setPosition(this.windowRect.x, this.windowRect.height + this.type.titleMargin + this.height * this.scale / 2);
        }
    },

    setTitle: function (msg) {
        this.text.setString(msg);

        this.onResize();
    },

    onResize: function () {
        const maxTextWidth = this.getMaxTextWidth();

        this.text.setFontSize(this.textFont.size);
        const baseTextWidth = this.text.width;

        this.text.fitTo(maxTextWidth, this.maxTextHeight);

        if (this.background) {
            const contentSize = this.getMaxContentSize(baseTextWidth >= maxTextWidth ? maxTextWidth : this.text.width);

            let scale = 1;

            if (this.type.background.scalable) {
                scale = contentSize.width / this.background.width;
                this.background.setScale(scale);
            } else {
                this.background.setContentSize2(contentSize);
            }

            this.setContentSize2(this.background.width * scale, this.background.height * scale);
            this.background.setAlignment(this.width / 2, this.height / 2);

            if (this.decors) {
                this.decors.updateAll();
            }
        } else {
            this.setContentSize2(this.text.getContentSize());
        }

        this.text.setAlignment(this.type.text);
        if (this.helpButton) {
            this.text.setAlignment(this.text.x + this.type.helpButton.padding.x, this.text.y);
            this.helpButton.setAlignment(this.type.helpButton);
        }
    },

    show: function () {
        if (this.withBg) {
            this.setVisible(true);
        } else {
            this.setOpacity(255);
            this.runAction(new cc.Sequence(
                new cc.DelayTime(0.1),
                new cc.MoveBy(0, 0, -this.type.offsetY),
                new cc.Show(),
                new cc.MoveBy(0.4, 0, this.type.offsetY).easing(cc.easeBackOut())
            ));
        }
    },

    hide: function () {
        if (this.withBg) {
            this.setVisible(false);
        } else {
            this.runAction(new cc.Spawn(
                new cc.ScaleTo(0.4, 0.6 * this.scale).easing(cc.easeBackIn()),
                new cc.FadeOut(0.4)
            ));
        }
    },

    getMaxTextWidth: function () {
        if (this.withBg) {
            return (this.windowRect.width - 2 * this.type.titleSideOffset.x) / this.scale
                - (this.background && this.help ? 2 * this.type.helpButton.padding.x : 0);
        }

        const sceneWidth = cleverapps.resolution.getSceneSize().width / this.scale;

        return sceneWidth - 2 * Math.max(
            this.type.text.scenePaddingX,
            (this.type.background ? this.type.background.padding.x : 0) + (this.helpButton ? this.type.helpButton.padding.x : 0)
        );
    },

    getMaxContentSize: function (textWidth) {
        if (!this.background) {
            return cc.size(textWidth, this.text.height);
        }

        const width = Math.max(
            textWidth + 2 * this.type.background.padding.x + 2 * (this.helpButton ? this.type.helpButton.padding.x : 0),
            cleverapps.resolution.isVertical() ? this.type.background.minWidthVertical : this.type.background.minWidth
        );

        return cc.size(width, this.type.background.height || this.background.height);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    WINDOW_TITLE_TEXT: {
        size: 70,
        color: cleverapps.styles.COLORS.COLOR_BROWN,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    NOBG_WINDOW_TITLE_TEXT: {
        size: 70,
        color: cleverapps.styles.COLORS.COLOR_BROWN,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    }
});

cleverapps.styles.WindowTitle = {
    Types: {
        bg_window: {
            scale: [0.9, 1, 1],
            background: {
                image: bundles.windows.frames.window_title_bg_png,
                height: 147,
                minWidth: 350,
                minWidthVertical: 350,
                padding: {
                    x: 40
                }
            },
            titleSideOffset: {
                x: 150
            },
            text: {
                x: { align: "center" },
                y: { align: "center", dy: 12 }
            },
            position: {
                x: { align: "center" },
                y: { align: "top", anchor: false, dy: -2 }
            },
            helpButton: {
                x: { align: "left", dx: 20 },
                y: { align: "center", dy: 3 },
                padding: {
                    x: 30
                },
                type: cleverapps.styles.UI.Button.Images.help_button_transparent
            }
        },

        nobg_window: {
            titleMargin: 30,
            scale: [0.75, 1, 1],
            fontSize: [45, 50, 50],
            background: {
                image: bundles.windows.frames.window_title_bg_secondary_png,
                height: 110,
                minWidth: 600,
                minWidthVertical: 550,
                padding: {
                    x: 195
                }
            },
            text: {
                x: { align: "center" },
                y: { align: "center", dy: 8 },
                scenePaddingX: 100
            },
            offsetY: 50,
            helpButton: {
                type: cleverapps.styles.UI.Button.Images.help_button_transparent
            }
        }
    }
};
